import React from 'react';
import Paytable from './Paytable/Paytable';
import Help from './Help/Help';
import Winlines from './Winlines/Winlines';
import Settings from './Settings/Settings';

import { IMenuPages } from '../MenuPages.types';

import { DOM_ID } from '@UILayer/UILayer.types';

export const HomeIcon: React.ReactNode = (
    <svg width="24" height="24" x="0px" y="0px" viewBox="0 0 24 24" fill="none">
        <path
            className="st0"
            d="M20.4,18.5V11c0-0.9-0.6-1.8-1.2-2.4l-5-4.2c-1.4-1.1-3.2-1.1-4.6,0l-5,4.2c-0.7,0.5-1,1.5-1,2.4v7.5
	c0,1.1,0.8,2,1.9,2h1.9c1,0,1.9-0.8,1.9-1.9v-3.1c0-1.1,0.8-2,1.9-2h1.9c1,0,1.9,0.9,1.9,2v3.1c0,1,0.8,1.9,1.9,1.9h1.9
	C19.6,20.4,20.4,19.5,20.4,18.5L20.4,18.5z"
            stroke="#A9ACB9"
        />
    </svg>
);

export const InGameHistoryIcon: React.ReactNode = (
    <svg width="24" height="24" x="0px" y="0px" fill="none" viewBox="0 0 24 24">
        <g>
            <g id="Layer_1_00000126306997468378132300000015794778742519554726_">
                <path
                    fill="#A9ACB9"
                    className="st0"
                    d="M10.5,8.8c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v3.7l2.4,1.1c0.4,0.2,0.6,0.7,0.4,1.1s-0.7,0.6-1.1,0.4
			l-2.9-1.3c-0.3-0.1-0.6-0.4-0.6-0.8C10.5,13,10.5,8.8,10.5,8.8z M3.7,9.1V8.9V6.5C3.5,6,3.9,5.6,4.4,5.6s0.9,0.3,0.9,0.8v0.4
			c0.4-0.5,0.8-0.9,1.2-1.3c0.6-0.5,1.3-0.9,2-1.3C10.6,3.2,13,3.3,15,4c2,0.8,3.7,2.3,4.7,4.4c0,0,0,0,0,0.1
			c0.9,2.1,0.9,4.4,0.1,6.4s-2.3,3.7-4.4,4.7c-0.1,0-0.3,0.1-0.4,0.1c-0.5,0-0.9-0.4-0.9-0.9s0.2-0.7,0.6-0.8
			c0.3-0.1,0.5-0.2,0.7-0.4l0,0c0.4-0.2,0.7-0.5,1.1-0.8l0,0c0.7-0.7,1.2-1.5,1.5-2.4c0.6-1.6,0.6-3.4-0.1-5.1l0,0
			c-0.8-1.7-2.1-2.9-3.7-3.5s-3.4-0.6-5.1,0.1C8.5,6.2,8,6.5,7.5,6.9C7.2,7.2,6.9,7.5,6.6,7.8h0.1c0.5,0,0.9,0.3,1,0.7
			s-0.3,0.9-0.8,1L4.5,9.8c-0.5,0-0.9-0.2-1-0.7L3.7,9.1z M12.9,20.4c0.7,0,1-0.9,0.6-1.4c-0.2-0.2-0.5-0.3-0.8-0.3
			c-0.5,0-1,0-1.5,0c-0.3,0-0.6,0-0.8,0.3c-0.4,0.5,0,1.3,0.6,1.4C11.6,20.4,12.3,20.4,12.9,20.4z M7.3,19.1c0.3,0.2,0.6,0.2,0.9,0
			c0.6-0.3,0.7-1.1,0-1.5c-0.4-0.3-0.8-0.6-1.2-1c-0.3-0.3-0.8-0.4-1.2,0c-0.4,0.3-0.4,0.9-0.1,1.2l0,0c0.4,0.5,0.9,0.9,1.5,1.3l0,0
			H7.3z M3.9,14.5c0,0.3,0.4,0.5,0.7,0.6c0.6,0.1,1.2-0.5,1-1.1c-0.2-0.5-0.2-1-0.3-1.5c0-0.6-0.7-1-1.2-0.7
			c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.6,0.2,1.3,0.4,1.9l0,0L3.9,14.5z"
                />
            </g>
        </g>
    </svg>
);

export const MenuPages: IMenuPages[] = [
    {
        id: 0,
        domId: DOM_ID.SETTINGS_PAGES_HEADER_PAYTABLE,
        pageHeader: 'SETTINGS_PAGE_HEADER_PAYTABLE',
        pageTabDescription: 'SETTINGS_PAGE_TAB_WCA_PAYTABLE',
        pageIcon: (
            <svg className="paytable_icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    className="st0"
                    d="M18,2.1c-0.9,0-2,1-2,2H8c0-1-1.1-2-2-2h-4V11c0,1,1,2,2,2h2.2c0.4,2,1.7,3.7,4.8,4V19c-3,0.5-3,2.9-3,2.9H16
	c0,0,0-2.4-3-2.9V17c3.1-0.3,4.4-2,4.8-4h2.2c1,0,2-1,2-2V2.1H18z M6,11h-2V4.1h2V11z M16,11.5c0,1.9-0.6,3.5-4,3.5
	c-3.4,0-4-1.6-4-3.5V6H16V11.5z M19.9,11h-2V4.1h2V11z"
                    fill="#A9ACB9"
                />
            </svg>
        ),
        content: <Paytable />
    },
    {
        id: 1,
        domId: DOM_ID.SETTINGS_PAGES_HEADER_HELP,
        pageHeader: 'SETTINGS_PAGE_HEADER_HELP',
        pageTabDescription: 'SETTINGS_PAGE_TAB_WCA_HELP',
        pageIcon: (
            <svg className="help_icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M12.2666 21C17.2372 21 21.2666 16.9706 21.2666 12C21.2666 7.02944 17.2372 3 12.2666 3C7.29604 3 3.2666 7.02944 3.2666 12C3.2666 16.9706 7.29604 21 12.2666 21Z"
                    stroke="#A9ACB9"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12.2666 16V12" stroke="#A9ACB9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.2666 8H12.2766" stroke="#A9ACB9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        content: <Help />
    },
    {
        id: 2,
        domId: DOM_ID.SETTINGS_PAGES_HEADER_WINLINES,
        pageHeader: 'SETTINGS_PAGE_HEADER_WINLINES',
        pageTabDescription: 'SETTINGS_PAGE_TAB_WCA_WINLINES',
        pageIcon: (
            <svg className="winline_icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clipPath="url(#clip0_1076_7661)">
                    <rect y="5" width="24" height="2" rx="1" fill="#A9ACB9" />
                    <rect y="11" width="24" height="2" rx="1" fill="#A9ACB9" />
                    <rect y="17" width="24" height="2" rx="1" fill="#A9ACB9" />
                    <rect x="1.58301" y="4.7998" width="25.4777" height="2" rx="1" transform="rotate(30 1.58301 4.7998)" fill="#A9ACB9" />
                    <rect x="0.398438" y="17.5117" width="25.7092" height="2" rx="1" transform="rotate(-30 0.398438 17.5117)" fill="#A9ACB9" />
                </g>
                <defs>
                    <clipPath id="clip0_1076_7661">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        ),
        content: <Winlines />
    },
    {
        id: 3,
        domId: DOM_ID.SETTINGS_PAGES_HEADER_SETTINGS,
        pageHeader: 'SETTINGS_PAGE_HEADER_SETTINGS',
        pageTabDescription: 'SETTINGS_PAGE_TAB_WCA_SETTINGS',
        pageIcon: (
            <svg className="game_settings_icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="#A9ACB9"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2705 4.54104C14.2705 3.68995 13.5806 3 12.7295 3H11.2708C10.4197 3 9.72978 3.68995 9.72978 4.54104C9.72978 5.19575 9.30691 5.76411 8.73157 6.07658C8.64162 6.12544 8.5529 6.17624 8.46547 6.22895C7.90058 6.56948 7.19265 6.65124 6.62015 6.32367C5.87307 5.89621 4.92106 6.15129 4.48779 6.89501L3.78337 8.10415C3.3518 8.84495 3.60649 9.79549 4.35063 10.2213C4.92067 10.5474 5.20445 11.1992 5.19056 11.8558C5.18954 11.9037 5.18903 11.9518 5.18903 12C5.18903 12.0482 5.18954 12.0963 5.19056 12.1443C5.20445 12.8009 4.92068 13.4526 4.35065 13.7787C3.60652 14.2045 3.35183 15.155 3.7834 15.8958L4.48784 17.105C4.92111 17.8487 5.8731 18.1038 6.62018 17.6763C7.19268 17.3488 7.90059 17.4305 8.46547 17.7711C8.5529 17.8238 8.64162 17.8746 8.73157 17.9234C9.30691 18.2359 9.72978 18.8042 9.72978 19.459C9.72978 20.3101 10.4197 21 11.2708 21H12.7295C13.5806 21 14.2705 20.3101 14.2705 19.459C14.2705 18.8042 14.6934 18.2359 15.2687 17.9234C15.3587 17.8746 15.4474 17.8238 15.5348 17.7711C16.0997 17.4305 16.8076 17.3488 17.3801 17.6763C18.1272 18.1038 19.0792 17.8487 19.5125 17.105L20.2169 15.8958C20.6485 15.1551 20.3938 14.2045 19.6496 13.7788C19.0796 13.4526 18.7958 12.8009 18.8097 12.1443C18.8107 12.0963 18.8113 12.0482 18.8113 12C18.8113 11.9518 18.8107 11.9037 18.8097 11.8558C18.7958 11.1992 19.0796 10.5474 19.6497 10.2213C20.3938 9.79548 20.6485 8.84494 20.2169 8.10414L19.5125 6.89501C19.0792 6.15128 18.1272 5.8962 17.3801 6.32366C16.8076 6.65123 16.0997 6.56948 15.5348 6.22894C15.4474 6.17624 15.3587 6.12543 15.2687 6.07658C14.6934 5.76411 14.2705 5.19575 14.2705 4.54104Z"
                    stroke="#A9ACB9"
                    strokeWidth="1.5"
                />
            </svg>
        ),
        content: <Settings />
    }
];
